import React, { useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Auth } from 'aws-amplify';

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  grid: {
    marginTop: theme.spacing(10)
  },
  paper: {
    padding: theme.spacing(3)
  },
  msg: {
    marginTop: '12px',
    color: '#f44336'
  },
  progress: {
    marginTop: '8px'
  }
}));

const Register = (props) => {
  const [user, setUser] = useState();
  const [code, setCode] = useState("");
  const [firstname, setFirstname] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [errorFirstname, setErrorFirstname] = useState("");
  const [errorSurname, setErrorSurname] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [errorPassword2, setErrorPassword2] = useState("");
  const [formMsg, setFormMsg] = useState("");
  const [isWaiting, setIsWaiting] = useState(false);

  const history = useHistory();
  const username = useMemo(() => (email ? email.toLowerCase().replace('@', '_._') : ""), [email]);

  const validateForm = () => {
    setFormMsg("Please correct your details ...");
    setErrorFirstname("");
    setErrorSurname("");
    setErrorEmail("");
    setErrorPassword("");
    setErrorPassword2("");
    if (firstname.length === 0) {
      setErrorFirstname("Enter your first name.");
      return false;
    }
    if (surname.length === 0) {
      setErrorSurname("Enter your surname.");
      return false;
    }
    if (email.length === 0) {
      setErrorEmail("Enter an email address.");
      return false;
    }
    if (!(email.includes("@")&&email.length > 3)) {
      setErrorEmail("Enter a valid email address.");
      return false;
    }
    // if (!(email.endsWith("@optus.com.au")||email.endsWith("@corrivium.com"))) {
    //   setErrorEmail("Sorry, only valid OPTUS email addresses can register.");
    //   return false;
    // }
    if (password.length === 0) {
      setErrorPassword("Enter a password.");
      return false;
    }
    if (password !== password2) {
      setErrorPassword2("Your passwords do not match.");
      return false;
    }
    setFormMsg("");
    return true;
  };

  const handleRegistrationSubmit = async (event) => {
    event.preventDefault();

    if (validateForm()) {
      setIsWaiting(true);
      setFormMsg("Registering ...");
      try {
        const user = await Auth.signUp({
          username: username,
          password: password,
          attributes: {
            email: email,
            given_name: firstname,
            family_name: surname
          }
        });
        setUser(user);
        setFormMsg("Please check your email inbox, and enter the activation code ...");
        setIsWaiting(false);
      } catch (e) {
        console.log(e);
        setIsWaiting(false);
        setFormMsg(e.message);
      }
    }
  };

  const handleConfirmationSubmit = async (event) => {
    event.preventDefault();

    if (validateForm()) {
      setIsWaiting(true);
      setFormMsg("Confirming Code ...");

      try {
        await Auth.confirmSignUp(username, code);
        const user = await Auth.signIn(username, password);
        setUser(user);
        setFormMsg("");
        setIsWaiting(false);
        history.push("/event");
      } catch (e) {
        console.log(e.message);
        setFormMsg(e.message);
        setIsWaiting(false);
      }
    }
  };

  const renderRegistrationForm = (props) => {
    return (
      <>
        <h2>Register</h2>
        <form noValidate autoComplete="off" onSubmit={handleRegistrationSubmit}>
          <Grid container spacing={1}>
            <Grid item sm={6}>
              <TextField
                id="firstname"
                label="Firstname"
                value={firstname}
                error={errorFirstname.length > 0}
                helperText={errorFirstname}
                onChange={e => setFirstname(e.target.value)}
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
                autoFocus
              />
            </Grid>
            <Grid item sm={6}>
              <TextField
                id="surname"
                label="Surname"
                value={surname}
                error={errorSurname.length > 0}
                helperText={errorSurname}
                onChange={e => setSurname(e.target.value)}
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
          </Grid>
          <TextField
            id="email"
            label="Email"
            value={email}
            error={errorEmail.length > 0}
            helperText={errorEmail}
            onChange={e => setEmail(e.target.value.trim().toLowerCase())}
            margin="normal"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            fullWidth
            autoFocus
          />
          <TextField
            id="password"
            label="Password"
            type="password"
            value={password}
            error={errorPassword.length > 0}
            helperText={errorPassword}
            onChange={e => setPassword(e.target.value)}
            margin="normal"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
          <TextField
            id="password2"
            label="Confirm Password"
            type="password"
            value={password2}
            error={errorPassword2.length > 0}
            helperText={errorPassword2}
            onChange={e => setPassword2(e.target.value)}
            margin="normal"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
          <Grid container>
            <Grid item xs={4}>
              <Button type="submit" variant="outlined" color="primary" disabled={isWaiting}>
                Register
            </Button>
            </Grid>
            <Grid item xs={1}>
              {isWaiting && (
                <CircularProgress size={20} className={classes.progress} />
              )}
            </Grid>
            <Grid item xs={7}>
              <h5 className={classes.msg}>{formMsg}</h5>
            </Grid>
          </Grid>
        </form>
      </>
    );
  };

  const renderConfirmationForm = (props) => {
    return (
      <>
        <h2>Confirm Email</h2>
        <form noValidate autoComplete="off" onSubmit={handleConfirmationSubmit}>
          <TextField
            id="code"
            label="Activation Code"
            value={code}
            type="tel"
            onChange={e => setCode(e.target.value)}
            margin="normal"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            fullWidth
            autoFocus
          />
          <Grid container>
            <Grid item xs={4}>
              <Button type="submit" variant="outlined" color="primary" disabled={isWaiting}>
                Submit
            </Button>
            </Grid>
            <Grid item xs={1}>
              {isWaiting && (
                <CircularProgress size={20} className={classes.progress} />
              )}
            </Grid>
            <Grid item xs={7}>
              <h5 className={classes.msg}>{formMsg}</h5>
            </Grid>
          </Grid>
        </form>
      </>
    );
  }

  const classes = useStyles();
  return (
    <Grid container justify='center'>
      <Grid item xs={10} sm={8} md={6} lg={5} className={classes.grid}>
        <Paper className={classes.paper}>
          {user ? renderConfirmationForm() : renderRegistrationForm()}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Register;